<template>
    <div>
        <div v-for="product of products"
             class="col-md-12 col-xs-12 summary-block schedule-header-title visit-header-date marker-cursor">
            <b class="fs-13">
                <div class="col-xs-6">
                    {{ product.product }}
                </div>
                <div class="col-xs-6 text-right">
                    Quantity: {{ product.quantity }}
                </div>
            </b>
        </div>
    </div>
</template>

<script>
export default {
    name: "productSummary",
    props: ['products']
}
</script>

<style scoped>
    .fs-13 {
        font-size: 13px;
    }
</style>